<template>
  <div class="p-3 w-full flex flex-col md:flex-row justify-center gap-4">
    <GolResFilterCard :label="$t('insideUae')">
      <template #icon>
        <faSignIn class="w-12 fill-primary" />
      </template>
    </GolResFilterCard>
    <GolResFilterCard :label="$t('outsideUae')">
      <template #icon>
        <faSignOut class="w-12 fill-primary" />
      </template>
    </GolResFilterCard>
  </div>
  <!-- <RouterView name="content" /> -->
</template>

<script setup>
import faSignIn from '@/assets/icons/faSignIn.svg?component'
import faSignOut from '@/assets/icons/faSignOut.svg?component'
import GolResFilterCard from '@/components/cards/GolResFilterCard.vue'
</script>

<script>
export default { name: 'GoldenResidencesIndex' }
</script>

<style lang="scss" scoped></style>
